// extracted by mini-css-extract-plugin
export default {"modelSelector":"calculation-form2__modelSelector___1uJLx","fullWidth":"calculation-form2__fullWidth___nLYrD"};